import JsBarcode from "jsbarcode";
import "jspdf-autotable";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import exportAsPDF from "../../Utils/exportAsPDF";
import { useAuth } from "../../context/userContext";

const GenerateDigitalBillReceipt = ({ clientName, items, handleShow, showModal, billRef, currency, appSettings, billDate, pointsEarned, cardNo }) => {
    const barcodeRef = useRef(null);
    const billFooter1 = appSettings?.BillFooter1;
    const billFooter2 = appSettings?.BillFooter2;
    const billDateFormatted = billDate ? moment(billDate).format("DD MM YYYY, hh:mm:ss a") : "";
    useEffect(() => {
        if (showModal && barcodeRef.current) {
            JsBarcode(barcodeRef.current, billRef || "", {
                format: "CODE128",
                lineColor: "#000",
                width: 2,
                height: 50,
                displayValue: false,
            });
        }
    }, [showModal]);

    
      const { authUser } = useAuth();

      console.log(authUser, 'authuser')

    const calculateTotal = () => {
        return items.filter((item) => item.QTY > 0).reduce((total, item) => total + item.RETAIL * item.QTY, 0);
    };

    const renderReceiptItems = () => {
        return items.map((item, index) => (
            <tr key={index}>
                <td>{item.DES}</td>
                <td className="text-end">{item.QTY}</td>
                <td className="text-end">{item.RETAIL.toFixed(2)}</td>
            </tr>
        ));
    };

    const downloadPDF = () => {
        exportAsPDF();
    };

    return (
        <div style={{ width: "100%" }}>
            {/* Modal */}
            {showModal && (
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    role="dialog"
                    style={{
                        display: showModal ? "block" : "none",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backdropFilter: "blur(10px)",
                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                        zIndex: 1000,
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        handleShow();
                    }}
                    data-bs-dismiss="modal"
                >
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        className="modal-dialog modal-dialog-centered"
                    >
                        <div className="modal-content bg-table-head-history">
                            <div className="d-flex justify-content-between p-2 algin-items-center">
                                <div className="d-flex align-items-center text-wafaa-dark-blue-2 ps-2" style={{ fontSize: "18px", fontWeight: "bold" }}>
                                    Digital Receipt
                                </div>
                                <button type="button" className="btn text-wafaa-dark-blue-2" style={{ fontSize: "18px" }} data-bs-dismiss="modal" aria-label="Close" onClick={handleShow}>
                                    X
                                </button>
                            </div>
                            <div
                                id="export-box"
                                className="modal-body"
                                style={{
                                    fontFamily: "Courier, monospace",
                                    padding: "10px",
                                    backgroundColor: "#fff",
                                    border: "none",
                                    maxWidth: "400px",
                                    margin: "auto",
                                }}
                            >
                                <h5
                                    className="text-center"
                                    style={{
                                        fontWeight: "bold",
                                        textTransform: "uppercase",
                                        marginBottom: "5px",
                                        marginTop: "1.5rem",
                                    }}
                                >
                                    {clientName ? clientName : "True Value"}
                                </h5>
                                <p className="text-center" style={{ fontSize: "12px", marginBottom: "5px" }}>
                                    {billDateFormatted}
                                </p>
                                <p className="text-center" style={{ fontSize: "12px", marginBottom: "5px" }}>
                                    Receipt #: {billRef || ""}
                                </p>
                                <hr style={{ borderTop: "2px dashed #000", marginBottom: "5px" }} />
                                <table className="table" style={{ fontSize: "14px", width: "100%", border: "1px solid white" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left" }}>Item</th>
                                            <th style={{ textAlign: "right" }}>Qty</th>
                                            <th style={{ textAlign: "right" }}>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>{renderReceiptItems()}</tbody>
                                </table>
                                <hr style={{ borderTop: "2px dashed #000", marginTop: "-10px" }} />
                                <div className="total" style={{ fontSize: "14px", fontWeight: "bold", textAlign: "right" }}>
                                    <p className="d-flex justify-content-between px-3">
                                        <span>Total:</span>
                                        <span>
                                            {currency} {calculateTotal().toFixed(2)}
                                        </span>
                                    </p>
                                </div>
                                <hr style={{ borderTop: "2px dashed #000" }} />
                                <div style={{ width: "100%", fontSize: "12px" }}>
                                    <p style={{margin: 0, padding: "0"}}>Card No. : {cardNo} </p>
                                    <p style={{margin: 0, padding: "0"}}>Cust Name : {authUser?.CUST_NAME} </p>
                                    <p style={{margin: 0, padding: "0"}}>Earned Points : {pointsEarned} </p>
                                </div>
                                <div
                                    style={{
                                        width: "92%",
                                        margin: "0 auto",
                                        paddingTop: "5px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <svg
                                        ref={barcodeRef}
                                        style={{
                                            width: "200px",
                                            height: "30px",
                                        }}
                                    />
                                </div>
                                <p className="text-center" style={{ fontSize: "12px", marginTop: "10px" }}>
                                    {billFooter1 ? billFooter1 : "Thank you for shopping with us!"}
                                </p>
                                <p className="text-center" style={{ fontSize: "12px", fontStyle: "italic" }}>
                                    {billFooter2 ? billFooter2 : "Visit Again"}
                                </p>
                            </div>

                            <div className="d-flex justify-content-center p-2">
                                <button
                                    onClick={downloadPDF}
                                    className="btn btn-primary bg-wafaa-purple font-size-14"
                                    style={{
                                        width: "100%",
                                        // height: "45px",
                                        color: "white",
                                        textTransform: "capitalize",
                                        // marginBlock: "1rem",
                                        border: "none",
                                        cursor: "pointer",
                                        borderRadius: "4px",
                                        webkittapHighlightColor: "none",
                                    }}
                                >
                                    Download PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GenerateDigitalBillReceipt;
